var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogosFacebook = function SvgLogosFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5Z",
    fill: "#602BE9"
  })));
};
export { SvgLogosFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDEzLjVIMTYuNUwxNy41IDkuNUgxNFY3LjVDMTQgNi40NyAxNCA1LjUgMTYgNS41SDE3LjVWMi4xNEMxNy4xNzQgMi4wOTcgMTUuOTQzIDIgMTQuNjQzIDJDMTEuOTI4IDIgMTAgMy42NTcgMTAgNi43VjkuNUg3VjEzLjVIMTBWMjJIMTRWMTMuNVoiIGZpbGw9IiM2MDJCRTkiLz4KPC9zdmc+Cg==";